export const POSTS = `https://jsonplaceholder.typicode.com/posts`
export const TODOS = `https://jsonplaceholder.typicode.com/todos`
export const USERS = `https://jsonplaceholder.typicode.com/users`
export const MAXLENGTH = 200
